<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-lps-nao-visita") {
            next({ name: "relatorio-lps-nao-visita-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-lps-nao-visita") {
            this.$router.push({ name: "relatorio-lps-nao-visita-list" });
        }
    },
};
</script>